import React from 'react'
import { Link } from '@fs/zion-router'
import { Trans } from 'react-i18next'

const translationKeyMap = {
  readAndAgree: 'groups.join.terms-check',
  acceptAndPermission: 'groups.accept-group-privacy',
}

type LegalLinksProps = {
  type: 'readAndAgree' | 'acceptAndPermission'
}
export default function LegalLinks({ type }: LegalLinksProps): JSX.Element | null {
  if (!translationKeyMap[type]) return null
  return (
    <Trans i18nKey={translationKeyMap[type]}>
      <Link target="_blank" to="https://www.familysearch.org/legal/familysearch-content-submission-agreement" />
      <Link target="_blank" to="https://www.familysearch.org/legal/terms" />
      <Link target="_blank" to="https://www.familysearch.org/legal/privacy" />
    </Trans>
  )
}
